// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var include = TypeUtils.MakeOpaqueStringType({});

var decode = include.decode;

var encode = include.encode;

function decode$1(json) {
  return Curry._2(Json.Decode.$less$pipe$great, Curry._1(decode, json), Curry._2(Json.Decode.$great$great$eq, Relude_Result.map((function (param) {
                        return Relude_Globals.$great$great(Relude_Int.toString, (function (prim) {
                                      return prim;
                                    }), param);
                      }), Json.Decode.intFromNumberOrString(json)), decode));
}

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode$1, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: encode
};

var Id_fromString = include.fromString;

var Id_toString = include.toString;

var Id_compare = include.compare;

var Id_eq = include.eq;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromString: Id_fromString,
  toString: Id_toString,
  encode: encode,
  compare: Id_compare,
  eq: Id_eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  decode: decode$1,
  GraphQL_API: GraphQL_API
};

var include$1 = TypeUtils.MakeOpaqueFloatType({});

var fromFloat = include$1.fromFloat;

var toFloat = include$1.toFloat;

function parse$1(param) {
  return Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, param);
}

var GraphQL_API$1 = {
  parse: parse$1,
  serialize: toFloat
};

var Duration_fromString = include$1.fromString;

var Duration_toString = include$1.toString;

var Duration_decode = include$1.decode;

var Duration_encode = include$1.encode;

var Duration_compare = include$1.compare;

var Duration_eq = include$1.eq;

var Duration_Ord = include$1.Ord;

var Duration_Set = include$1.$$Set;

var Duration_Map = include$1.$$Map;

var Duration = {
  fromFloat: fromFloat,
  fromString: Duration_fromString,
  toFloat: toFloat,
  toString: Duration_toString,
  decode: Duration_decode,
  encode: Duration_encode,
  compare: Duration_compare,
  eq: Duration_eq,
  Ord: Duration_Ord,
  $$Set: Duration_Set,
  $$Map: Duration_Map,
  GraphQL_API: GraphQL_API$1
};

var include$2 = TypeUtils.MakeOpaqueIntType({});

var fromInt = include$2.fromInt;

var toInt = include$2.toInt;

function parse$2(param) {
  return Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, param);
}

var GraphQL_API$2 = {
  parse: parse$2,
  serialize: toInt
};

var DurationPayCents_fromString = include$2.fromString;

var DurationPayCents_toString = include$2.toString;

var DurationPayCents_decode = include$2.decode;

var DurationPayCents_encode = include$2.encode;

var DurationPayCents_compare = include$2.compare;

var DurationPayCents_eq = include$2.eq;

var DurationPayCents_Ord = include$2.Ord;

var DurationPayCents_Set = include$2.$$Set;

var DurationPayCents_Map = include$2.$$Map;

var DurationPayCents = {
  fromInt: fromInt,
  fromString: DurationPayCents_fromString,
  toInt: toInt,
  toString: DurationPayCents_toString,
  decode: DurationPayCents_decode,
  encode: DurationPayCents_encode,
  compare: DurationPayCents_compare,
  eq: DurationPayCents_eq,
  Ord: DurationPayCents_Ord,
  $$Set: DurationPayCents_Set,
  $$Map: DurationPayCents_Map,
  GraphQL_API: GraphQL_API$2
};

function fromEnum(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 3;
  }
}

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* Voided */0;
    case 1 :
        return /* Normal */1;
    case 2 :
        return /* LastMinuteShift */2;
    default:
      return ;
  }
}

var include$3 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

function fromString(x) {
  switch (x) {
    case "Last-minute Shift" :
        return /* LastMinuteShift */2;
    case "Normal" :
        return /* Normal */1;
    case "Voided" :
        return /* Voided */0;
    default:
      return /* FutureAddedValue */{
              _0: x
            };
  }
}

function toString(x) {
  if (typeof x !== "number") {
    return x._0;
  }
  switch (x) {
    case /* Voided */0 :
        return "Voided";
    case /* Normal */1 :
        return "Normal";
    case /* LastMinuteShift */2 :
        return "Last-minute Shift";
    
  }
}

function parseApiResponse(param) {
  if (typeof param === "string") {
    if (param === "VOIDED") {
      return /* Voided */0;
    } else if (param === "LAST_MINUTE_SHIFT") {
      return /* LastMinuteShift */2;
    } else {
      return /* Normal */1;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

var decode$2 = Curry._1(Json.Decode.variantFromString, (function (param) {
        return Relude_Globals.$great$great(fromString, Relude_Option.pure, param);
      }));

function encode$1(param) {
  return Relude_Globals.$great$great(toString, (function (prim) {
                return prim;
              }), param);
}

var AcceptanceCategory_fromEnum = include$3.fromEnum;

var AcceptanceCategory_toEnum = include$3.toEnum;

var AcceptanceCategory_eq = include$3.eq;

var AcceptanceCategory_compare = include$3.compare;

var AcceptanceCategory_Ord = include$3.Ord;

var AcceptanceCategory_compareWithConversion = include$3.compareWithConversion;

var AcceptanceCategory_compareReversed = include$3.compareReversed;

var AcceptanceCategory_OrdReversed = include$3.OrdReversed;

var AcceptanceCategory_compareAsInt = include$3.compareAsInt;

var AcceptanceCategory_min = include$3.min;

var AcceptanceCategory_max = include$3.max;

var AcceptanceCategory_lessThan = include$3.lessThan;

var AcceptanceCategory_lt = include$3.lt;

var AcceptanceCategory_lessThanOrEq = include$3.lessThanOrEq;

var AcceptanceCategory_lte = include$3.lte;

var AcceptanceCategory_greaterThan = include$3.greaterThan;

var AcceptanceCategory_gt = include$3.gt;

var AcceptanceCategory_greaterThanOrEq = include$3.greaterThanOrEq;

var AcceptanceCategory_gte = include$3.gte;

var AcceptanceCategory_clamp = include$3.clamp;

var AcceptanceCategory_between = include$3.between;

var AcceptanceCategory_OrdRingExtensions = include$3.OrdRingExtensions;

var AcceptanceCategory_OrdNamed = include$3.OrdNamed;

var AcceptanceCategory_OrdBy = include$3.OrdBy;

var AcceptanceCategory_Set = include$3.$$Set;

var AcceptanceCategory_SetWithNone = include$3.SetWithNone;

var AcceptanceCategory_Map = include$3.$$Map;

var AcceptanceCategory_list = include$3.list;

var AcceptanceCategory_array = include$3.array;

var AcceptanceCategory_set = include$3.set;

var AcceptanceCategory_setWithNone = include$3.setWithNone;

var AcceptanceCategory_cardinality = include$3.cardinality;

var AcceptanceCategory_top = include$3.top;

var AcceptanceCategory_bottom = include$3.bottom;

var AcceptanceCategory_succ = include$3.succ;

var AcceptanceCategory_pred = include$3.pred;

var AcceptanceCategory = {
  fromEnum: AcceptanceCategory_fromEnum,
  toEnum: AcceptanceCategory_toEnum,
  eq: AcceptanceCategory_eq,
  compare: AcceptanceCategory_compare,
  Ord: AcceptanceCategory_Ord,
  compareWithConversion: AcceptanceCategory_compareWithConversion,
  compareReversed: AcceptanceCategory_compareReversed,
  OrdReversed: AcceptanceCategory_OrdReversed,
  compareAsInt: AcceptanceCategory_compareAsInt,
  min: AcceptanceCategory_min,
  max: AcceptanceCategory_max,
  lessThan: AcceptanceCategory_lessThan,
  lt: AcceptanceCategory_lt,
  lessThanOrEq: AcceptanceCategory_lessThanOrEq,
  lte: AcceptanceCategory_lte,
  greaterThan: AcceptanceCategory_greaterThan,
  gt: AcceptanceCategory_gt,
  greaterThanOrEq: AcceptanceCategory_greaterThanOrEq,
  gte: AcceptanceCategory_gte,
  clamp: AcceptanceCategory_clamp,
  between: AcceptanceCategory_between,
  OrdRingExtensions: AcceptanceCategory_OrdRingExtensions,
  OrdNamed: AcceptanceCategory_OrdNamed,
  OrdBy: AcceptanceCategory_OrdBy,
  $$Set: AcceptanceCategory_Set,
  SetWithNone: AcceptanceCategory_SetWithNone,
  $$Map: AcceptanceCategory_Map,
  list: AcceptanceCategory_list,
  array: AcceptanceCategory_array,
  set: AcceptanceCategory_set,
  setWithNone: AcceptanceCategory_setWithNone,
  cardinality: AcceptanceCategory_cardinality,
  top: AcceptanceCategory_top,
  bottom: AcceptanceCategory_bottom,
  succ: AcceptanceCategory_succ,
  pred: AcceptanceCategory_pred,
  fromString: fromString,
  toString: toString,
  parseApiResponse: parseApiResponse,
  decode: decode$2,
  encode: encode$1
};

function fromEnum$1(param) {
  if (typeof param === "number") {
    if (param !== 0) {
      return 1;
    } else {
      return 0;
    }
  } else {
    return 2;
  }
}

function toEnum$1(param) {
  if (param !== 0) {
    if (param !== 1) {
      return ;
    } else {
      return /* Normal */1;
    }
  } else {
    return /* Orientation */0;
  }
}

var include$4 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$1,
      toEnum: toEnum$1
    });

function fromString$1(x) {
  switch (x) {
    case "Normal" :
        return /* Normal */1;
    case "Orientation" :
        return /* Orientation */0;
    default:
      return /* FutureAddedValue */{
              _0: x
            };
  }
}

function toString$1(x) {
  if (typeof x === "number") {
    if (x !== 0) {
      return "Normal";
    } else {
      return "Orientation";
    }
  } else {
    return x._0;
  }
}

var decode$3 = Curry._1(Json.Decode.variantFromString, (function (param) {
        return Relude_Globals.$great$great(fromString$1, Relude_Option.pure, param);
      }));

function encode$2(param) {
  return Relude_Globals.$great$great(toString$1, (function (prim) {
                return prim;
              }), param);
}

var Category_fromEnum = include$4.fromEnum;

var Category_toEnum = include$4.toEnum;

var Category_eq = include$4.eq;

var Category_compare = include$4.compare;

var Category_Ord = include$4.Ord;

var Category_compareWithConversion = include$4.compareWithConversion;

var Category_compareReversed = include$4.compareReversed;

var Category_OrdReversed = include$4.OrdReversed;

var Category_compareAsInt = include$4.compareAsInt;

var Category_min = include$4.min;

var Category_max = include$4.max;

var Category_lessThan = include$4.lessThan;

var Category_lt = include$4.lt;

var Category_lessThanOrEq = include$4.lessThanOrEq;

var Category_lte = include$4.lte;

var Category_greaterThan = include$4.greaterThan;

var Category_gt = include$4.gt;

var Category_greaterThanOrEq = include$4.greaterThanOrEq;

var Category_gte = include$4.gte;

var Category_clamp = include$4.clamp;

var Category_between = include$4.between;

var Category_OrdRingExtensions = include$4.OrdRingExtensions;

var Category_OrdNamed = include$4.OrdNamed;

var Category_OrdBy = include$4.OrdBy;

var Category_Set = include$4.$$Set;

var Category_SetWithNone = include$4.SetWithNone;

var Category_Map = include$4.$$Map;

var Category_list = include$4.list;

var Category_array = include$4.array;

var Category_set = include$4.set;

var Category_setWithNone = include$4.setWithNone;

var Category_cardinality = include$4.cardinality;

var Category_top = include$4.top;

var Category_bottom = include$4.bottom;

var Category_succ = include$4.succ;

var Category_pred = include$4.pred;

var Category = {
  fromEnum: Category_fromEnum,
  toEnum: Category_toEnum,
  eq: Category_eq,
  compare: Category_compare,
  Ord: Category_Ord,
  compareWithConversion: Category_compareWithConversion,
  compareReversed: Category_compareReversed,
  OrdReversed: Category_OrdReversed,
  compareAsInt: Category_compareAsInt,
  min: Category_min,
  max: Category_max,
  lessThan: Category_lessThan,
  lt: Category_lt,
  lessThanOrEq: Category_lessThanOrEq,
  lte: Category_lte,
  greaterThan: Category_greaterThan,
  gt: Category_gt,
  greaterThanOrEq: Category_greaterThanOrEq,
  gte: Category_gte,
  clamp: Category_clamp,
  between: Category_between,
  OrdRingExtensions: Category_OrdRingExtensions,
  OrdNamed: Category_OrdNamed,
  OrdBy: Category_OrdBy,
  $$Set: Category_Set,
  SetWithNone: Category_SetWithNone,
  $$Map: Category_Map,
  list: Category_list,
  array: Category_array,
  set: Category_set,
  setWithNone: Category_setWithNone,
  cardinality: Category_cardinality,
  top: Category_top,
  bottom: Category_bottom,
  succ: Category_succ,
  pred: Category_pred,
  fromString: fromString$1,
  toString: toString$1,
  decode: decode$3,
  encode: encode$2
};

function fromEnum$2(param) {
  if (typeof param === "number") {
    if (param !== 0) {
      return 1;
    } else {
      return 0;
    }
  } else {
    return 2;
  }
}

function toEnum$2(param) {
  if (param !== 0) {
    if (param !== 1) {
      return ;
    } else {
      return /* NeedsClockIn */1;
    }
  } else {
    return /* NeedsDayOfConfirmation */0;
  }
}

var include$5 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$2,
      toEnum: toEnum$2
    });

function parseApiResponse$1(param) {
  if (typeof param === "string") {
    if (param === "NEEDS_CLOCK_IN") {
      return /* NeedsClockIn */1;
    } else {
      return /* NeedsDayOfConfirmation */0;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function toString$2(str) {
  if (typeof str === "number") {
    if (str !== 0) {
      return "Not clocked in";
    } else {
      return "Not confirmed";
    }
  } else {
    return str._0;
  }
}

var OpsAction_fromEnum = include$5.fromEnum;

var OpsAction_toEnum = include$5.toEnum;

var OpsAction_eq = include$5.eq;

var OpsAction_compare = include$5.compare;

var OpsAction_Ord = include$5.Ord;

var OpsAction_compareWithConversion = include$5.compareWithConversion;

var OpsAction_compareReversed = include$5.compareReversed;

var OpsAction_OrdReversed = include$5.OrdReversed;

var OpsAction_compareAsInt = include$5.compareAsInt;

var OpsAction_min = include$5.min;

var OpsAction_max = include$5.max;

var OpsAction_lessThan = include$5.lessThan;

var OpsAction_lt = include$5.lt;

var OpsAction_lessThanOrEq = include$5.lessThanOrEq;

var OpsAction_lte = include$5.lte;

var OpsAction_greaterThan = include$5.greaterThan;

var OpsAction_gt = include$5.gt;

var OpsAction_greaterThanOrEq = include$5.greaterThanOrEq;

var OpsAction_gte = include$5.gte;

var OpsAction_clamp = include$5.clamp;

var OpsAction_between = include$5.between;

var OpsAction_OrdRingExtensions = include$5.OrdRingExtensions;

var OpsAction_OrdNamed = include$5.OrdNamed;

var OpsAction_OrdBy = include$5.OrdBy;

var OpsAction_Set = include$5.$$Set;

var OpsAction_SetWithNone = include$5.SetWithNone;

var OpsAction_Map = include$5.$$Map;

var OpsAction_list = include$5.list;

var OpsAction_array = include$5.array;

var OpsAction_set = include$5.set;

var OpsAction_setWithNone = include$5.setWithNone;

var OpsAction_cardinality = include$5.cardinality;

var OpsAction_top = include$5.top;

var OpsAction_bottom = include$5.bottom;

var OpsAction_succ = include$5.succ;

var OpsAction_pred = include$5.pred;

var OpsAction = {
  fromEnum: OpsAction_fromEnum,
  toEnum: OpsAction_toEnum,
  eq: OpsAction_eq,
  compare: OpsAction_compare,
  Ord: OpsAction_Ord,
  compareWithConversion: OpsAction_compareWithConversion,
  compareReversed: OpsAction_compareReversed,
  OrdReversed: OpsAction_OrdReversed,
  compareAsInt: OpsAction_compareAsInt,
  min: OpsAction_min,
  max: OpsAction_max,
  lessThan: OpsAction_lessThan,
  lt: OpsAction_lt,
  lessThanOrEq: OpsAction_lessThanOrEq,
  lte: OpsAction_lte,
  greaterThan: OpsAction_greaterThan,
  gt: OpsAction_gt,
  greaterThanOrEq: OpsAction_greaterThanOrEq,
  gte: OpsAction_gte,
  clamp: OpsAction_clamp,
  between: OpsAction_between,
  OrdRingExtensions: OpsAction_OrdRingExtensions,
  OrdNamed: OpsAction_OrdNamed,
  OrdBy: OpsAction_OrdBy,
  $$Set: OpsAction_Set,
  SetWithNone: OpsAction_SetWithNone,
  $$Map: OpsAction_Map,
  list: OpsAction_list,
  array: OpsAction_array,
  set: OpsAction_set,
  setWithNone: OpsAction_setWithNone,
  cardinality: OpsAction_cardinality,
  top: OpsAction_top,
  bottom: OpsAction_bottom,
  succ: OpsAction_succ,
  pred: OpsAction_pred,
  parseApiResponse: parseApiResponse$1,
  toString: toString$2
};

function fromEnum$3(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 4;
  }
}

function toEnum$3(param) {
  switch (param) {
    case 0 :
        return /* LastMinuteShift */0;
    case 1 :
        return /* FirstShiftForProfessional */1;
    case 2 :
        return /* RequestedProfessional */2;
    case 3 :
        return /* LowPercentageProfessional */3;
    default:
      return ;
  }
}

var include$6 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$3,
      toEnum: toEnum$3
    });

function parseApiResponse$2(param) {
  if (typeof param === "string") {
    if (param === "LOW_PERCENTAGE_PROFESSIONAL") {
      return /* LowPercentageProfessional */3;
    } else if (param === "REQUESTED_PROFESSIONAL") {
      return /* RequestedProfessional */2;
    } else if (param === "LAST_MINUTE_SHIFT") {
      return /* LastMinuteShift */0;
    } else {
      return /* FirstShiftForProfessional */1;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function toString$3(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* LastMinuteShift */0 :
        return "Last Minute Shift";
    case /* FirstShiftForProfessional */1 :
        return "Pro's First Shift";
    case /* RequestedProfessional */2 :
        return "Requested Pro";
    case /* LowPercentageProfessional */3 :
        return "Low Percentile Pro";
    
  }
}

var Note_fromEnum = include$6.fromEnum;

var Note_toEnum = include$6.toEnum;

var Note_eq = include$6.eq;

var Note_compare = include$6.compare;

var Note_Ord = include$6.Ord;

var Note_compareWithConversion = include$6.compareWithConversion;

var Note_compareReversed = include$6.compareReversed;

var Note_OrdReversed = include$6.OrdReversed;

var Note_compareAsInt = include$6.compareAsInt;

var Note_min = include$6.min;

var Note_max = include$6.max;

var Note_lessThan = include$6.lessThan;

var Note_lt = include$6.lt;

var Note_lessThanOrEq = include$6.lessThanOrEq;

var Note_lte = include$6.lte;

var Note_greaterThan = include$6.greaterThan;

var Note_gt = include$6.gt;

var Note_greaterThanOrEq = include$6.greaterThanOrEq;

var Note_gte = include$6.gte;

var Note_clamp = include$6.clamp;

var Note_between = include$6.between;

var Note_OrdRingExtensions = include$6.OrdRingExtensions;

var Note_OrdNamed = include$6.OrdNamed;

var Note_OrdBy = include$6.OrdBy;

var Note_Set = include$6.$$Set;

var Note_SetWithNone = include$6.SetWithNone;

var Note_Map = include$6.$$Map;

var Note_list = include$6.list;

var Note_array = include$6.array;

var Note_set = include$6.set;

var Note_setWithNone = include$6.setWithNone;

var Note_cardinality = include$6.cardinality;

var Note_top = include$6.top;

var Note_bottom = include$6.bottom;

var Note_succ = include$6.succ;

var Note_pred = include$6.pred;

var Note = {
  fromEnum: Note_fromEnum,
  toEnum: Note_toEnum,
  eq: Note_eq,
  compare: Note_compare,
  Ord: Note_Ord,
  compareWithConversion: Note_compareWithConversion,
  compareReversed: Note_compareReversed,
  OrdReversed: Note_OrdReversed,
  compareAsInt: Note_compareAsInt,
  min: Note_min,
  max: Note_max,
  lessThan: Note_lessThan,
  lt: Note_lt,
  lessThanOrEq: Note_lessThanOrEq,
  lte: Note_lte,
  greaterThan: Note_greaterThan,
  gt: Note_gt,
  greaterThanOrEq: Note_greaterThanOrEq,
  gte: Note_gte,
  clamp: Note_clamp,
  between: Note_between,
  OrdRingExtensions: Note_OrdRingExtensions,
  OrdNamed: Note_OrdNamed,
  OrdBy: Note_OrdBy,
  $$Set: Note_Set,
  SetWithNone: Note_SetWithNone,
  $$Map: Note_Map,
  list: Note_list,
  array: Note_array,
  set: Note_set,
  setWithNone: Note_setWithNone,
  cardinality: Note_cardinality,
  top: Note_top,
  bottom: Note_bottom,
  succ: Note_succ,
  pred: Note_pred,
  parseApiResponse: parseApiResponse$2,
  toString: toString$3
};

function parseApiResponse$3(param) {
  if (typeof param === "string") {
    if (param === "CONFIRMATION_VIEWED") {
      return /* ConfirmationViewd */0;
    } else if (param === "TRANSFERRED_PAYMENT") {
      return /* TransferredPayment */3;
    } else if (param === "PAID") {
      return /* Paid */4;
    } else if (param === "CLOCK_IN_VIEWED") {
      return /* ClockInViewed */2;
    } else {
      return /* RunningLate */1;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function toString$4(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* ConfirmationViewd */0 :
        return "Conf viewed";
    case /* RunningLate */1 :
        return "Running Late";
    case /* ClockInViewed */2 :
        return "Clock-In Screen Viewed";
    case /* TransferredPayment */3 :
        return "Transferred";
    case /* Paid */4 :
        return "Paid";
    
  }
}

var Status = {
  parseApiResponse: parseApiResponse$3,
  toString: toString$4
};

function earnedTips(param_0) {
  return /* EarnedTips */{
          _0: param_0
        };
}

var PayTipsAmountInput = {
  noTipsEarned: /* NoTipsEarned */0,
  earnedTips: earnedTips
};

function encode$3(param) {
  var tipAmount = param.tipAmount;
  return Json.Encode.object_({
              hd: [
                "amountCents",
                tipAmount ? tipAmount._0 : 0
              ],
              tl: {
                hd: [
                  "workerShiftId",
                  Curry._1(encode, param.workerShiftId)
                ],
                tl: /* [] */0
              }
            });
}

var PayTipsInput = {
  encode: encode$3
};

var QwickScore = TypeUtils.MakeOpaqueFloatType({});

var QwickScorePotential = TypeUtils.MakeOpaqueIntType({});

exports.Id = Id;
exports.Duration = Duration;
exports.DurationPayCents = DurationPayCents;
exports.AcceptanceCategory = AcceptanceCategory;
exports.Category = Category;
exports.OpsAction = OpsAction;
exports.Note = Note;
exports.Status = Status;
exports.PayTipsAmountInput = PayTipsAmountInput;
exports.PayTipsInput = PayTipsInput;
exports.QwickScore = QwickScore;
exports.QwickScorePotential = QwickScorePotential;
/* include Not a pure module */
